<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_fusion_eu_title' | translate }}</h4>
  <form #form="ngForm">
    <mat-card>
      <h4 mat-dialog-title>{{ 'common_section_identification' | translate }}</h4>
      <div class="row">
        <div class="col-3">
          <mat-form-field>
            <mat-label>{{ 'common_field_code' | translate }}</mat-label>
            <input matInput type="text" [(ngModel)]="newEu.code" name="code" cdkFocusInitial required />
            <mat-error *ngIf="!newEu?.code" [innerHTML]="'common_error_code_required' | translate"></mat-error>
          </mat-form-field>
        </div>
        <div class="col-5">
          <mat-form-field>
            <mat-label>{{ 'common_field_label' | translate }}</mat-label>
            <input matInput type="text" [(ngModel)]="newEu.displayName" name="displayName" maxlength="256" required />
            <mat-hint align="end">{{ newEu?.displayName?.length || 0 }} / 256</mat-hint>
            <mat-error *ngIf="!newEu?.displayName" [innerHTML]="'dialog_scenario_error_label_required' | translate"></mat-error>
          </mat-form-field>
        </div>
        <div class="col-4">
          <mat-form-field>
            <mat-label>{{ 'common_field_parent' | translate }}</mat-label>
            <input matInput [(ngModel)]="newEu.parent" name="parent" disabled />
          </mat-form-field>
        </div>
      </div>
    </mat-card>
    <mat-card>
      <h4 mat-dialog-title>{{ 'dialog_fusion_eu_section_eu' | translate }}</h4>
      <ul class="list-eu">
        <li *ngFor="let eu of data.listEu">
          <mat-checkbox (change)="changeCheckBox($event, eu)">
            {{ eu?.displayName }}
          </mat-checkbox>
        </li>
      </ul>
    </mat-card>

    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="newEu" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
